import { GameManager } from "./GameManager";
import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class PreLoader extends Phaser.State {

    public static currentInstance: PreLoader;

    private preloadBar: Phaser.Sprite;
    private preloadBarContainer: Phaser.Group;

    public init(): void {

        PreLoader.currentInstance = this;
    }

    public preload(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameLoadingStart();
        }

        this.generateBitmapData();

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameLoadingFinished();
        }

        this.game.add.tween(this.preloadBarContainer)
            .to({alpha: 0}, 450, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {
                GameManager.init(this.game);
            }, this);
    }

    private updateLoadedPercentage(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            PokiSDK.gameLoadingProgress({percentageDone: this.load.progress});
        }

        this.preloadBar.scale.x = this.load.progress / 100 * 3.925;
    }

    private composeScene(): void {

        // para usar aqui la fuente por primera vez
        this.add.text(0, 50, "abcdefg", { font: "38px Roboto Slab Bold", fill: "#FFFFFF", align: "center" });
        this.add.text(0, 100, "abcdefg", { font: "38px Roboto Slab Regular", fill: "#FFFFFF", align: "center" });
        this.add.text(0, 150, "abcdefg", { font: "38px Roboto Slab Light", fill: "#FFFFFF", align: "center" });
        this.add.text(0, 200, "abcdefg", { font: "46px Exo SemiBold", fill: "#FFFFFF", align: "center" });
        this.add.text(0, 250, "abcdefg", { font: "46px Exo Light", fill: "#FFFFFF", align: "center" });
        
        const backgroundImage = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background_splash");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.y = GameVars.scaleY;
        
        this.preloadBarContainer = this.add.group();
        this.preloadBarContainer.scale.y = GameVars.scaleY;
        this.preloadBarContainer.x = GameConstants.GAME_WIDTH / 2;
        this.preloadBarContainer.y = GameConstants.GAME_HEIGHT / 2;
        
        let preloadBarCapsuleShadow = new Phaser.Sprite(this.game, 2, 2, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        preloadBarCapsuleShadow.scale.set(4, .2);
        preloadBarCapsuleShadow.anchor.set(.5);
        preloadBarCapsuleShadow.alpha = .45;
        this.preloadBarContainer.add(preloadBarCapsuleShadow);

        let preloadBarCapsule = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.WHITE_SQUARE));
        preloadBarCapsule.scale.setTo(4, .2);
        preloadBarCapsule.anchor.set(.5);
        this.preloadBarContainer.add(preloadBarCapsule);

        this.preloadBar = new Phaser.Sprite(this.game, -126, 0 , this.game.cache.getBitmapData(GameConstants.RED_SQUARE));
        this.preloadBar.scale.setTo(0, .16);
        this.preloadBar.anchor.set(0, .5);
        this.preloadBarContainer.add(this.preloadBar);
    }

    private loadAssets(): void {

        if (GameConstants.DEVELOPMENT) {
            this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
        }

        this.load.json("problems-data", "assets/config/problems.json");
        this.load.json("languages", "assets/texts/languages.json");

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2_en", "assets/texture_atlas_2_en.png", "assets/texture_atlas_2_en.json");
        this.load.atlas("texture_atlas_2_fr", "assets/texture_atlas_2_fr.png", "assets/texture_atlas_2_fr.json");

        this.load.bitmapFont("roboto-slab", "assets/fonts/roboto-slab.png", "assets/fonts/roboto-slab.xml");
        

        this.load.audiosprite("audio-sprite", ["assets/audio/audiosprite.mp3", "assets/audio/audiosprite.ogg"], "assets/audio/audiosprite.json");

        this.game.load.start();

        this.load.onFileComplete.add(this.updateLoadedPercentage, this);
    }

    private generateBitmapData(): void {

        let bmd: Phaser.BitmapData  =  this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.RED_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FF0000";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#00FF00";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.OLIVE_GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#65aa46";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.BLUE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#0000FF";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.WHITE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#F6F9EF";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.BLACK_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#000000";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.GRAY_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#999999";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE , GameConstants.BITMAP_SIZE, GameConstants.DARK_BLUE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#1b2d3d";
        bmd.ctx.fill();

        bmd = this.game.add.bitmapData( GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE, GameConstants.GAME_WHITE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants.BITMAP_SIZE, GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = GameConstants.TEXT_COLOR_WHITE;
        bmd.ctx.fill();
    }
}
